import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActionCompletion, Actions, ofActionCompleted, Select, Store} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {OrdersState} from '../../states/orders.state';
import {FetchOrders} from '../../states/orders.actions';
import {takeUntil} from 'rxjs/operators';
import ResponseHandlingHelper from '../../helpers/response-handling-helper';
import {OrdersModelResponse} from '../../api/responses/orders-response';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {PushMenuActiveAccountId} from 'src/app/states/menu.actions';
import {HttpErrorCode} from 'src/app/api/http-error-code.enum';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-orders-page',
  templateUrl: './orders-page.component.html',
  styleUrls: ['./orders-page.component.scss']
})
export class OrdersPageComponent implements OnInit, OnDestroy {

    public accountId: number;

    @Select(OrdersState.orders)
    public ordersListener: Observable<OrdersModelResponse[]>;
    public orders: OrdersModelResponse[] = [];

    /**
     * Określa czy aktualnie trwa pobieranie danych.
     */
    public isLoading = false;

    /**
     * Token służący do anulowania pobierania danych.
     */
    private cancellationToken = new Subject();

    private gc = new Subject();

    constructor(
        private store: Store,
        private actions: Actions,
        private router: Router,
        private route: ActivatedRoute,
        private title: Title
    ) {
    }

    public ngOnInit() {
        this.title.setTitle('Orders & Invoices - Dataedo Account');
        this.initEvents();
    }

    private fetchData() {
        this.cancellationToken.next();
        this.isLoading = true;

        this.store.dispatch(new FetchOrders(this.accountId, this.cancellationToken));
    }

    private initEvents() {
        this.route.params
            .pipe(takeUntil(this.gc))
            .subscribe(params => this.onPathChange(params));

        this.ordersListener
            .pipe(takeUntil(this.gc))
            .subscribe(orders => this.orders = orders);

        this.actions
            .pipe(ofActionCompleted(FetchOrders))
            .pipe(takeUntil(this.gc))
            .subscribe(event => this.onCompletedFetchOrders(event));
    }

    private onPathChange(params: Params) {
        this.accountId = parseInt(params.accountId, 10);
        this.store.dispatch(new PushMenuActiveAccountId(this.accountId));
        this.fetchData();
    }

    private async onCompletedFetchOrders(event: ActionCompletion<FetchOrders, Error>) {
        const response = ResponseHandlingHelper.parse(event.result);
        if (response.isError && response.error.status === HttpErrorCode.Forbidden) {
            await this.router.navigate(['/accounts', this.accountId]);
        }

        this.isLoading = false;
    }

    public trackById(index: number, order: OrdersModelResponse): number {
        return order.id;
    }

    public ngOnDestroy(): void {
        this.cancellationToken.next();
        this.cancellationToken.complete();

        this.gc.next();
        this.gc.complete();
    }
}
